import { fork, all, spawn } from 'redux-saga/effects'

//import child sagas
import {
  login,
  loginAs,
  logout,
  signup,
  resetPass,
  confirmResetPass,
  resetPassBySms,
  confirmResetPassBySms,
} from './authenticationSaga'

import {
  profileUpdate,
  fetchProfileInfo,
  changeEmail,
  changePassword,
  removeUser,
  fetchCities,
  fetchStates,
  sendEmailVerification,
  sendSmsVerification,
  verifyEmail,
  verifyPhone,
  fetchDistricts,
  fetchContactsInfo,

  fetchProfileDocumentsGroup,
  uploadUserProfileDocument,
  removeUserProfileDocument,
} from './profileSaga'

import { fetchGrades } from './gradesSaga'

import { fetchLevels } from './levelsSaga'

import { fetchAcademicYears } from './academicYearsSaga'

import {
  importStudents,
  getStudentsList,
  uploadStudentDocument,
  getStudentsDocuments,
  removeStudentDocument,
  fetchStudentBadges,
} from './studentsSaga'

import {
  getSchoolsList,
  getStudentsOfSchool,
  removeStudentFromSchool,
  addSingleStudentToSchool,
} from './schoolsSaga'

import { getTeachersList } from './teachersSaga'

import {
  getSupervisorsList,
  getStudentsOfSupervisor,
  removeStudentFromSupervisor,

  fetchSupervisorEvents,
  fetchSupervisorEventStudents,
  fetchSupervisorEventHosts,
  fetchSupervisorEventSchools,
  fetchSupervisorSchoolEventStudents,
  fetchSupervisorHost,
  supervisorAddHost,
  supervisorRemoveHost,
  editSupervisorHost,
  addStudentsToSupervisorHost,
  removeStudentsFromSupervisorHost,
  supervisorFinishEvnetHostingSetup,

  supervisorAddPromoCode,
  supervisorUpdatePromoCode,
  supervisorFetchSinglePromoCode,

  supervisorFetchEventPromoCodes,
  supervisorFetchEventDocuments,
} from './supervisorsSaga'

import { getAppsList } from './appsSaga'

import {
  changeUserVerificationStatus,
  addStudentToSchool,
  addStudentToSupervisor,
  fetchServiceStats,
} from './managersSaga'

import {
  fetchEvents,
  fetchSingleEvent,
  addEvent,
  purchaseEvent,
  fetchUserEvents,
  fetchEventCategories,
  checkEventTopStudents,
  deleteEventTicket,
  editEvent,
  fetchEventTemplates,
  deleteEventExtension,
  fetchBoughtEvents,
} from './eventsSaga'

import {
  fetchUserMessages,
  getSingleMessage,
  getNotifications,
  SeenStatus,
  sendMessage,
  broadcastMessage,
  BroadcastedMessages,
  getSingleBroadcast,
  getUserBroadcasts,
  getBroadcastNotifications,
  getManagerEmails,
  getManagerSms,
  sendEmail,
  getSingleEmail,
  sendSms,
} from './messagesSaga'

import {
  fetchCourseTopics,
  fetchUserCourses,
  addCourse,
  attachContentToCourse,
  updateCourseInfo,
  fetchCourseContents,
  deleteContentOfCourse,
  updateContentOfCourse,
  fetchListOfAllCourses,
  purchaseCourse,
  fetchBoughtCourses,
  fetchSingleCourse,
} from './coursesSaga'

import {
  fetchBuyOrders,
  payPendingOrder,
  cancelPendingOrder,
  createOrderForService,
  fetchSingleOrder,
  updateOrder,
  payOrder,
} from './ordersSaga'

import { fetchUserBalance, requestPayment, confirmRecharge } from './creditSaga'

import { fetchUserStats } from './statsSaga'

import { applyDiscountCode } from './ordersSaga'

import {
  createQuestion,
  watchFetchListOfQuestions,
  createOnlineTest,
  addTopicsToTest,
  addQuestionsToTest,
  fetchTestsList,
  fetchSingleTest,
  createTestTicketOrder,
  fetchUserTestTicketOrders,
  takeTheTest,
  checkStatusOfTest,
  startTest,
  submitStashedAnswersImmediately,
  fetchResultOfTest,
  fetchListOfQuestionsForEventMaker,
  removeQuestionFromTest,
} from './onlineTestSaga'

import { getFeaturedItems } from './featuredSaga'

import { getStaticContent, getStaticHeader } from './staticPages'

import { getUserCertificates } from './certificatesSaga'

import { fetchServiceData } from './servicesSaga'

import {
  fetchSingleSupportTicket,
  fetchSupportTickets,
  createSupportTicket,
  createSupportTicketReply,
} from './supportSaga'

//authentication saga
function* authSaga() {
  yield all([
    fork(login),
    fork(loginAs),
    fork(logout),
    fork(signup),
    fork(resetPass),
    fork(resetPassBySms),
    fork(confirmResetPass),
    fork(confirmResetPassBySms),
  ])
}

function* profileSagas() {
  yield all([
    fork(profileUpdate),
    fork(fetchProfileInfo),
    fork(changeEmail),
    fork(changePassword),
    fork(removeUser),
    fork(fetchCities),
    fork(fetchStates),
    fork(sendEmailVerification),
    fork(verifyEmail),
    fork(sendSmsVerification),
    fork(verifyPhone),
    fork(fetchDistricts),
    fork(fetchContactsInfo),

    fork(fetchProfileDocumentsGroup),
    fork(uploadUserProfileDocument),
    fork(removeUserProfileDocument),
  ])
}

function* generalFetchSagas() {
  yield all([fork(fetchGrades), fork(fetchLevels), fork(fetchAcademicYears)])
}

function* studentsSagas() {
  yield all([
    fork(importStudents),
    fork(getStudentsList),
    fork(uploadStudentDocument),
    fork(getStudentsDocuments),
    fork(removeStudentDocument),
    fork(fetchStudentBadges),
  ])
}

function* schoolsSaga() {
  yield all([
    fork(getSchoolsList),
    fork(getStudentsOfSchool),
    fork(removeStudentFromSchool),
    fork(addSingleStudentToSchool),
  ])
}

function* teachersSaga() {
  yield all([fork(getTeachersList)])
}

function* eventsSaga() {
  yield all([
    fork(fetchEvents),
    fork(fetchSingleEvent),
    fork(fetchEventCategories),
    fork(addEvent),
    fork(purchaseEvent),
    fork(fetchUserEvents),
    fork(checkEventTopStudents),
    fork(deleteEventTicket),
    fork(editEvent),
    fork(fetchEventTemplates),
    fork(deleteEventTicket),
    fork(deleteEventExtension),
    fork(fetchBoughtEvents),
  ])
}

function* supervisorsSaga() {
  yield all([
    fork(getSupervisorsList),
    fork(getStudentsOfSupervisor),
    fork(removeStudentFromSupervisor),

    fork(fetchSupervisorEvents),
    fork(fetchSupervisorEventStudents),
    fork(fetchSupervisorEventHosts),
    fork(fetchSupervisorEventSchools),
    fork(fetchSupervisorSchoolEventStudents),
    fork(fetchSupervisorHost),
    fork(supervisorAddHost),
    fork(supervisorRemoveHost),
    fork(editSupervisorHost),
    fork(addStudentsToSupervisorHost),
    fork(removeStudentsFromSupervisorHost),
    fork(supervisorFinishEvnetHostingSetup),

    fork(supervisorFetchEventPromoCodes),
    fork(supervisorFetchSinglePromoCode),
    fork(supervisorUpdatePromoCode),
    fork(supervisorAddPromoCode),

    fork(supervisorFetchEventDocuments),
  ])
}

function* appsSaga() {
  yield all([fork(getAppsList)])
}

function* managerSaga() {
  yield all([
    fork(changeUserVerificationStatus),
    fork(addStudentToSchool),
    fork(addStudentToSupervisor),
    fork(fetchServiceStats),
  ])
}

function* coursesSaga() {
  yield all([
    fork(fetchCourseTopics),
    fork(fetchUserCourses),
    fork(addCourse),
    fork(attachContentToCourse),
    fork(updateCourseInfo),
    fork(fetchCourseContents),
    fork(deleteContentOfCourse),
    fork(updateContentOfCourse),
    fork(fetchListOfAllCourses),
    fork(purchaseCourse),
    fork(fetchBoughtCourses),
    fork(fetchSingleCourse),
  ])
}

function* messagesSaga() {
  yield all([
    fork(fetchUserMessages),
    fork(getNotifications),
    fork(getSingleMessage),
    fork(SeenStatus),
    fork(sendMessage),
    fork(broadcastMessage),
    fork(BroadcastedMessages),
    fork(getSingleBroadcast),
    fork(getUserBroadcasts),
    fork(getBroadcastNotifications),
    fork(getManagerEmails),
    fork(sendEmail),
    fork(getManagerSms),
    fork(getSingleEmail),
    fork(sendSms),
  ])
}

function* ordersSaga() {
  yield all([
    fork(fetchBuyOrders),
    fork(payPendingOrder),
    fork(applyDiscountCode),
    fork(cancelPendingOrder),
    fork(createOrderForService),
    fork(fetchSingleOrder),
    fork(updateOrder),
    fork(payOrder),
  ])
}

function* creditSaga() {
  yield all([fork(fetchUserBalance), fork(requestPayment), fork(confirmRecharge)])
}

function* statsSaga() {
  yield all([fork(fetchUserStats)])
}

function* staticContent() {
  yield all([fork(getStaticContent), fork(getStaticHeader)])
}

function* onlineTestSaga() {
  yield all([
    fork(createQuestion),
    fork(watchFetchListOfQuestions),
    fork(createOnlineTest),
    fork(addTopicsToTest),
    fork(addQuestionsToTest),
    fork(fetchTestsList),
    fork(fetchSingleTest),
    fork(createTestTicketOrder),
    fork(fetchUserTestTicketOrders),
    fork(takeTheTest),
    fork(checkStatusOfTest),
    fork(startTest),
    fork(submitStashedAnswersImmediately),
    fork(fetchResultOfTest),
    fork(fetchListOfQuestionsForEventMaker),
    fork(removeQuestionFromTest),
  ])
}

function* servicesSaga() {
  yield all([fork(fetchServiceData)])
}

function* supportSaga() {
  yield all([
    fork(fetchSingleSupportTicket),
    fork(fetchSupportTickets),
    fork(createSupportTicket),
    fork(createSupportTicketReply),
  ])
}

//root saga, spawns all sagas
function* rootSaga() {
  yield all([
    spawn(authSaga),
    spawn(profileSagas),
    spawn(generalFetchSagas),
    spawn(studentsSagas),
    spawn(schoolsSaga),
    spawn(teachersSaga),
    spawn(supervisorsSaga),
    spawn(appsSaga),
    spawn(managerSaga),
    spawn(messagesSaga),
    spawn(eventsSaga),
    spawn(coursesSaga),
    spawn(ordersSaga),
    spawn(creditSaga),
    spawn(onlineTestSaga),
    spawn(statsSaga),
    spawn(getFeaturedItems),
    spawn(staticContent),
    spawn(getUserCertificates),
    spawn(servicesSaga),
    spawn(supportSaga),
  ])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/sagas/sagas.js